module.exports = __webpack_public_path__ + "img/lCallHB.0cc1bc2d.svg";